
<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    width="80%"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div>
      <el-form
        ref="entityData"
        :model="entityData"
        :rules="rules"
        label-width="80px"
        class="demo-ruleForm"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card>
              <div slot="header">任务/事件</div>
              <div>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="任务/名称">
                      <span>{{ eventInfo.workEventName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="负责人">
                      <span>{{ eventInfo.leaderName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="任务期间">
                      <span>{{ eventInfo.beginDateShow }}</span>
                      <span>~</span>
                      <span>{{ eventInfo.endDateShow }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="任务描述">
                      <span v-html="eventInfo.workEventDescribe" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <div>
                  <el-divider content-position="left">事件</el-divider>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="事件名称">
                        <span>{{ nodeInfo.nodeName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="负责人">
                        <span>{{ nodeInfo.leaderName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14">
                      <el-form-item label-width="120px" label="预定完成时间">
                        <span>{{ nodeInfo.endTimeShow }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <el-form-item label="事件状态">
                        <span>{{ nodeInfo.nodeStatusDictKeyItemName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14">
                      <el-form-item label-width="120px" label="推进类型">
                        <span>{{ nodeInfo.nodeAdvanceDictKeyItemName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="审核状态">
                        <span>{{ nodeInfo.auditStatusName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="nodeInfo.auditerUserId01" :span="8">
                      <el-form-item label-width="120px" label="一级">
                        <span>{{ nodeInfo.auditerUserId01Name }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="nodeInfo.auditerUserId01" :span="2">
                      <el-form-item label-width="0">
                        <i :class="getCheckAuditClassName(nodeInfo.auditResult01)" />
                      </el-form-item>
                    </el-col>
                    <el-row>
                      <el-col v-if="nodeInfo.auditerUserId02" :span="8">
                        <el-form-item label="二级">
                          <span>{{ nodeInfo.auditerUserId02Name }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col v-if="nodeInfo.auditerUserId02" :span="2">
                        <el-form-item label-width="0">
                          <i :class="getCheckAuditClassName(nodeInfo.auditResult02)" />
                        </el-form-item>
                      </el-col>
                      <el-col v-if="nodeInfo.auditerUserId03" :span="8">
                        <el-form-item label-width="120px" label="三级">
                          <span>{{ nodeInfo.auditerUserId03Name }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col v-if="nodeInfo.auditerUserId03" :span="2">
                        <el-form-item label-width="0">
                          <i :class="getCheckAuditClassName(nodeInfo.auditResult03)" />
                        </el-form-item>
                      </el-col>

                    </el-row>
                    <el-col :span="24">
                      <el-form-item label="事件描述">
                        <span>{{ nodeInfo.nodeDescribe }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参与人员">
                        <el-select v-model="selectedMembersId" multiple disabled>
                          <el-option
                            v-for="item in workEventMember"
                            :key="item.id"
                            :label="item.userName"
                            :value="item.id"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="followType==1">
                  <el-divider content-position="left">审核</el-divider>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="">
                        <el-switch
                          v-model="entityData.flag"
                          active-text="通过"
                          inactive-text="驳回"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="审核意见" style="margin-bottom: 22px;" prop="describe">
                        <el-input v-model="entityData.describe" type="textarea" :rows="5" />
                      </el-form-item>
                    </el-col>
                  </el-row>

                </div>
                <div v-if="followType==2">
                  <el-divider content-position="left">跟进</el-divider>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="跟进详细" style="margin-bottom: 22px;" prop="followMessage">
                        <el-input v-model="entityData.followMessage" type="textarea" :rows="5" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="nodeInfo.nodeStatusDictKey!=='D8701'">
                    <el-col :span="24">
                      <el-form-item label="状态">
                        <el-select v-model="entityData.nodeStatusDictKey" placeholder="请选择任务状态">
                          <el-option
                            v-for="item in getComboxData('D87')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <div slot="header">节点信息</div>
              <div style="height:605px;overflow-y:scroll">
                <div v-for="(item,idx) in timeLineList" :key="idx">
                  <span>{{ item.operationDatetimeShow }}</span> --
                  <span>{{ item.operationUserName }}</span>
                  <span v-if="item.nodeStatusNewDictKeyItemName">--{{ item.nodeStatusNewDictKeyItemName }}</span>
                  <span style="float:right;padding-right:20px">{{ item.operationAction }}</span>
                  <p>{{ item.operationDescribe }}</p>
                  <el-divider content-position="left" />
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <div style="float:left">
        <el-button v-if="followType==1 && nodeInfo.auditButtonEnable" type="primary" @click="handleAudit">{{ getAuditText }}</el-button>
        <el-button v-if="followType==2 " type="primary" @click="handleNodeFollow">跟进</el-button>
      </div>
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
// import Combox from '@/views/managesystem/gz/com/Combox'
export default {
  // components: { Combox },
  props: {
    value: { type: Boolean, default: false },
    nodeKey: { type: Number, default: null },
    followType: { type: Number, default: 1 } // 1审核 2跟进
    // workEventKey: { type: Number, default: null },
    // moduleCode: { type: String, default: '' },
    // moduleKey: { type: Number, default: null }
  },
  data() {
    return {
      entityData: {
        flag: true,
        describe: '',
        followMessage: '',
        nodeStatusDictKey: ''
        // operationDatetime:null
      },
      workEventMember: [],
      selectedMembersId: [],
      nodeInfo: {},
      eventInfo: {},
      timeLineList: [],
      rules: {
        describe: [{ required: true, message: '请输入审核意见', trigger: 'change,blur' }],
        followMessage: [{ required: true, message: '请输入跟进详细', trigger: 'change,blur' }]
        // nodeStatusDictKey: [{ required: true, message: '请选择任务状态', trigger: 'change,blur' }]
      }
    }
  },
  computed: {
    title() {
      return this.followType === 1 ? '审核' : '跟进'
    },
    getAuditText() {
      var btnText = '审核'
      if (this.nodeInfo.auditButtonEnable) {
        switch (this.nodeInfo.currentAuditLevel) {
          case 1:
            btnText = '一级审核'
            break
          case 2:
            btnText = '二级审核'
            break
          case 3:
            btnText = '三级审核'
            break
          default:
            break
        }
      }
      return btnText
    }

  },
  created() {
    /** 下拉框数据 */
    const that = this
    pathReq.getComboxDatasByIdArray('D86;D87').then(res => {
      that.allComboxData = res.data.result
    }).then(r => {
      that.allComboxData.forEach(item => {
        if (item.value === 'D8701') {
          item.disabled = true
        }
      })
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    getCheckAuditClassName(v) {
      var ret = 'el-icon-minus'
      switch (v) {
        case 1:
          ret = 'el-icon-check'
          break
        case 2:
          ret = 'el-icon-close'
      }
      return ret
    },
    /** 关闭窗口 */
    handleClose() {
      this.$refs['entityData'].resetFields()
      this.$emit('input', false)
    },
    /** 打开窗口 */
    handleOpen() {
      const that = this
      let path = '/api/services/app/WorkEventNode/GetNodeInfo'
      path += '?Id=' + this.nodeKey
      // path += '?moduleCode=' + this.moduleCode
      // path += '&moduleKey=' + this.moduleKey
      // path += '&eventKey=' + this.workEventKey
      // if (this.nodeKey) {
      //   path += 'Id=' + this.nodeKey
      // }

      pathReq.getNoParams(path).then(res => {
        that.nodeInfo = res.data.result.nodeInfo
        that.entityData.nodeStatusDictKey = res.data.result.nodeInfo.nodeStatusDictKey
        that.workEventMember = res.data.result.workEventMember
        that.selectedMembersId = res.data.result.selectedMembersId
        that.eventInfo = res.data.result.eventInfo
        that.timeLineList = res.data.result.timeLineList
      })
    },
    /** 审核 */
    handleAudit() {
      this.$refs['entityData'].validate((valid) => {
        if (valid) {
          var data = this.entityData
          data.nodeKey = this.nodeInfo.id
          data.currentAuditLevel = this.nodeInfo.currentAuditLevel

          const that = this
          const path = '/api/services/app/WorkEventNode/WorkEventNodeAudit'

          pathReq
            .dataUpdate(path, data)
            .then(res => {
              that.$message.success('审核成功')
              that.$refs['entityData'].resetFields()
              that.$emit('save-success')
              that.$emit('input', false)
            })
        }
      })
    },
    /** 跟进 */
    handleNodeFollow() {
      this.$refs['entityData'].validate((valid) => {
        if (valid) {
          var data = {
            'workEventKey': this.eventInfo.id,
            'nodeKey': this.nodeInfo.id,
            'nodeType': 3,
            // 'operationDatetime': '2021-09-13T09:12:26.019Z',
            // 'operationUserId': 0,
            'operationAction': '跟进',
            'operationDescribe': this.entityData.followMessage
            // 'nodeStatusOldDictKey': this.nodeInfo.nodeStatusDictKey,
            // 'nodeStatusNewDictKey': this.entityData.nodeStatusDictKey
            // 'completeRate': 0,
            // 'currentCompleteRate': 0,
            // 'id': 0
          }
          if (this.nodeInfo.nodeStatusDictKey !== this.entityData.nodeStatusDictKey) {
            data.nodeStatusOldDictKey = this.nodeInfo.nodeStatusDictKey
            data.nodeStatusNewDictKey = this.entityData.nodeStatusDictKey
          }

          const that = this
          const path = '/api/services/app/WorkEventNode/AddNodeFollow'

          pathReq
            .dataUpdate(path, data)
            .then(res => {
              that.$message.success('保存成功')
              that.$refs['entityData'].resetFields()
              that.$emit('save-success')
              that.$emit('input', false)
            })
        }
      })
    }
  }
}
</script>
<style scoped>
  .el-form-item{
    margin-bottom: 1px;
  }
</style>
